export enum WalletConnectError {
    None,
    PasskeyError,
    NotRegistered,
    NotConnected,
    NotApprovedByAdmin
}
